
import React, { useState } from 'react';








function Main() {
    const Data = [
        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/1.JPG",
            category: "fresher'sNight2016",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/2.JPG",
            category: "fresher'sNight2016",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/3.JPG",
            category: "fresher'sNight2016",
        },
        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/4.JPG",
            category: "fresher'sNight2016",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/5.JPG",
            category: "fresher'sNight2016",
        },
        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2016/6.JPG",
            category: "fresher'sNight2016",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/1.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/2.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/3.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/4.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/5.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/6.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/7.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/8.jpg",
            category: "fresher'sNight2015",
        },

        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/9.jpg",
            category: "fresher'sNight2015",
        },


        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/10.jpg",
            category: "fresher'sNight2015",
        },


        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/11.jpg",
            category: "fresher'sNight2015",
        },


        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/12.jpg",
            category: "fresher'sNight2015",
        },


        {
            img: "https://files.iittp.ac.in/images/demo/iit/Events/FreshersNight/13.jpg",
            category: "fresher'sNight2015",
        },
    ];

    const [current, setcurrent] = useState(Data);
    const [filterState, setFilterState] = useState("View All");

    const Filter = (category) => {
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
            setFilterState("View All");
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
                return null;
            });
            setcurrent(arr);
            setFilterState(category);
        }
    };

    const isActive = (value) => {
        return filterState === value ? "active" : "";
    };

    return (
        <>
            <section id="work" className="pb-105">
                <div className="container">
                    <div className="portfolio ">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div
                                    className="my-masonry text-center mb-50 wow fadeInRight  animated"
                                    data-animation="fadeInRight"
                                    data-delay=".4s"
                                >
                                    <div className="button-group filter-button-group ">
                                        <button
                                            className={isActive("View All")}
                                            data-filter="*"
                                            onClick={() => Filter("View All")}
                                        >
                                            {" "}
                                            View All{" "}
                                        </button>
                                        <button
                                            className={isActive(
                                                "fresher'sNight2016"
                                            )}
                                            data-filter=".fresher'sNight2016"
                                            onClick={() =>
                                                Filter("fresher'sNight2016")
                                            }
                                        >
                                            Fresher's Night 2016
                                        </button>
                                        <button
                                            className={isActive(
                                                "fresher'sNight2015"
                                            )}
                                            data-filter=".fresher'sNight2015"
                                            onClick={() =>
                                                Filter("fresher'sNight2015")
                                            }
                                        >
                                            Fresher's Night 2015
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="grid col3 row wow fadeInUp  animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            {current.map((item, Index) => (
                                <div
                                    className="grid-item financial col-4"
                                    key={Index}
                                >
                                    <figure className="gallery-image">
                                        <img
                                            src={item.img}
                                            alt="img"
                                            className="img"
                                        />
                                    </figure>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Main;
